<!-- -->
<template>
  <img v-if="img&&!error" class="avatar-box" @error="errorImage" :src="img.startsWith('http')?img:filePath+img"
       :style="{width: width+'px',height: height+'px'}"/>
  <div v-else="" class="avatar-box" :style="{width: width+'px',height: height+'px',fontSize: fontSize+'px'}">
    {{ nameText }}
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String
    },
    //:class="{male:gender===2,un:gender===0}"
    gender: {
      type: Number,
      default: 1
    },
    width: {
      type: Number,
      default: 40
    },
    height: {
      type: Number,
      default: 40
    },
    fontSize: {
      type: Number,
      default: 18
    },
    text: {
      type: String,
    }
  },
  name: "user-avatar",
  data() {
    return {
      error:false,
    }
  },
  computed: {
    nameText() {
      if (this.text) {
        return this.text.substr(0, 1);
      }
      return this.$store.state.user && this.$store.state.user.nickName ? this.$store.state.user.nickName.substr(0, 1) : "";
    },
  },
  mixins: [tableBase],
  methods: {
    errorImage(e) {
      e.onerror = null;
      this.error = true;
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.avatar-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: @primary;
  color: #fff;
  border-radius: 50%;

  &.male {
    background-color: @danger;
  }

  &.un {
    background-color: @message;
  }
}
</style>
